import { render, staticRenderFns } from "./StatisticsTableItem.vue?vue&type=template&id=74529b3e&scoped=true&"
import script from "./StatisticsTableItem.vue?vue&type=script&lang=js&"
export * from "./StatisticsTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74529b3e",
  null
  
)

export default component.exports